
import { defineComponent } from '@nuxtjs/composition-api'
import { replaceLinks } from '~/assets/ts/DynamicLinks'

export default defineComponent({
  props: ['text'],
  setup() {
    return { replaceLinks }
  },
})
